/**
 * Scroll to an element when "top"
 * param is greater than offset top of the $el
 * This plugin uses https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior
 *
 * requires polyfill in older browsers
 *  - https://github.com/wessberg/scroll-behavior-polyfill
 *  - https://github.com/iamdustan/smoothscroll
 *
 * @param $el
 * @param $parent
 * @param top
 */
import { querySelectorAll } from 'dom-helpers';

const scrollToEl = ($el, _$parent = document.body, top = 30, options = {}) => {
    if (typeof $el === 'string') {
        $el = querySelectorAll(document.body, $el)?.[0];
    }

    if ($el) {
        $el.scrollIntoView({ behavior: 'smooth', top, ...options });
    }
};

export default scrollToEl;
